import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
	selector: 'component-comment',
	templateUrl: './component.comment.html',
	styleUrls: ['./component.comment.css']
})
export class ComponentComment implements OnInit, AfterViewInit {
	@Input() commentList : any;
	@Input() relationId : any;
	@Input() studentList :any;
	@Input() tabNum : any;
	commentFlag : any;
	relationIdUrl : any;
	constructor(
		private route: ActivatedRoute,
		private router: Router,) {
		}
    ngOnInit() {
		let list =JSON.parse(JSON.stringify(this.commentList));
		list.map(item=>{
			let time = null; 
			if(item.studentCommentAt && typeof(item.studentCommentAt) != "undefined"){
				time = item.studentCommentAt.split('.')[0].split('T');
				item.studentCommentAt = time[0]+" " +time[1].split(":")[0]+":"+time[1].split(":")[1];
			}
			if(item.studentCommentByName.length > 10){
				item.studentCommentByName = item.studentCommentByName.slice(0,10)+"...";
			}
		})
		this.commentList = list;
		this.route.queryParams.subscribe(queryParams=>{
			this.commentFlag = !!queryParams['commentFlag'];
			this.relationIdUrl = queryParams['relationId'];
		})
	}
		
	ngAfterViewInit(){
		if(this.commentFlag){
			//评论后跳转到对应位置
			let index = null;

			if(this.tabNum == 1){
				this.studentList.forEach(item=>{
					if(item['userCampExerciseQuestionOperationLogVO'].relationId == this.relationIdUrl){
					  index = item['userCampExerciseQuestionOperationLogVO'].studentCommentList.length-1 ;
					}
				})
			}else if(this.tabNum == 0){
				index = this.commentList.length-1;
		
			}	
		  let ele = document.querySelector(`.single_comment-${this.relationIdUrl}-${index}`);
		  if(ele){
			ele.scrollIntoView();
		  }

		}

	}

	
}


// WEBPACK FOOTER //
// ./src/component/comment/component.comment.ts